import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPendingStatus = createSelector(
  [(store: RootState) => store.documentUpdate.pendingStatus],
  (data) => data
);
